"use client";

import { openSignIn } from "./dialog-events";

/**
 * Opens the sign-in dialog. data-closes-menu lets the site menu close itself
 * when the button sits inside it.
 */
export function SignInButton({ label, wide = false }: { label: string; wide?: boolean }) {
  return (
    <button
      className={wide ? "btn btn-ghost login-open" : "btn btn-ghost btn-sm login-open"}
      type="button"
      aria-haspopup="dialog"
      data-closes-menu=""
      onClick={(event) => openSignIn(event.currentTarget)}
    >
      {label}
    </button>
  );
}
